import { useLocation } from "react-router-dom";
import { IPageTabNavLink } from "../../interfaces-and-types";
import { View } from "./View";

export const PageTabNavLinks = ({
  pageTabNavLinks,
}: {
  pageTabNavLinks: IPageTabNavLink[];
}) => {
  const location = useLocation();

  return <View pageTabNavLinks={pageTabNavLinks} search={location.search} />;
};
